import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";
import { AppResponse } from "../../../../models/app/AppResponse";
import { Country } from "../../../../models/features/Shipping/Shipping";

export const shippingApi = createApi({
  reducerPath: "shippingApi",
  baseQuery: axiosBaseQuery(),

  endpoints: (build) => ({
    getCountries: build.query<AppResponse<Country>, void>({
      query: () => ({
        url: `api/Shopify/GetCountries`,
      }),
    }),
    getDeliveryProfiles: build.query<any, void>({
      query: () => ({
        url: `api/Shopify/GetDeliveryProfiles`,
      }),
    }),
    getDeliveryProfileDetail: build.mutation<any, { profileId: string }>({
      query: (data) => ({
        url: `api/Shopify/GetDeliveryProfileDetail`,
        method: "post",
        data: data,
      }),
    }),
    getDeliveryProfileData: build.mutation<any, { profileId: string }>({
      query: (data) => ({
        url: `api/Shopify/GetDeliveryProfileData`,
        method: "post",
        data: data,
      }),
    }),
    getDeliveryProfileItems: build.mutation<any, { profileId: string }>({
      query: (data) => ({
        url: `api/Shopify/GetDeliveryProfileItems`,
        method: "post",
        data: data,
      }),
    }),
    getDeliveryProfileLocation: build.mutation<any, { profileId: string }>({
      query: (data) => ({
        url: `api/Shopify/GetDeliveryProfileLocation`,
        method: "post",
        data: data,
      }),
    }),
    addDeliveryProfile: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/Shopify/AddDeliveryProfile`,
        method: "post",
        data: data,
      }),
    }),
    updateDeliveryProfile: build.mutation<any, { data: any; profileId: any }>({
      query: (data) => ({
        url: `api/Shopify/UpdateDeliveryProfile?profileId=${data.profileId}`,
        method: "post",
        data: data.data,
      }),
    }),

    DeleteDeliveryProfile: build.mutation<any, { profileId: any }>({
      query: ({ profileId }) => ({
        url: `api/Shopify/DeleteDeliveryProfile?profileId=${profileId}`,
        method: "post",
        data: null,
      }),
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useGetDeliveryProfilesQuery,
  useGetDeliveryProfileDetailMutation,
  useGetDeliveryProfileDataMutation,
  useGetDeliveryProfileItemsMutation,
  useGetDeliveryProfileLocationMutation,
  useAddDeliveryProfileMutation,
  useUpdateDeliveryProfileMutation,
  useDeleteDeliveryProfileMutation,
} = shippingApi;
export const shippingReducer = shippingApi.reducer;
